import { createSlice } from "@reduxjs/toolkit";

const gptSlice = createSlice({
    name:"gpt",
    initialState:{
        showGptSearch:false,
        movieResults:null,
        movieNames:null,
        loading: false,
    },
    reducers:{
        toggleGptSearchView:(state)=>{
            state.showGptSearch=! state.showGptSearch;
        },
        addGptMovieResult:(state, action)=>{
            const{movieNames, movieResults} = action.payload
            state.movieNames= movieNames;
             state.movieResults= movieResults;
        },
         setLoading: (state, action) => {
            state.loading = action.payload;
        },
        clearMovieResults: (state) => {
            state.movieResults = null;
           // state.loading = false;
        },
    }
})
export default gptSlice.reducer;
export const {toggleGptSearchView, addGptMovieResult,setLoading,clearMovieResults} =gptSlice.actions;